import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "om-consult-order-elsewhere-completion",
  templateUrl: "./consult-order-elsewhere-completion.component.html",
  styleUrls: ["./consult-order-elsewhere-completion.component.scss"],
})
export class ConsultOrderElsewhereCompletionComponent implements OnInit {
  @Output() completed = new EventEmitter();
  @Output() close = new EventEmitter();

  modalRef: NgbModalRef;
  @ViewChild("modal") modal;
  providerOrFacilityName = "";
  cityName = "";

  constructor(private modalService: NgbModal) {}

  ngOnInit() {}

  closeSelected() {
    this.close.emit();
  }

  complete() {
    this.completed.emit({
      completionData: {
        other_provider: {
          provider_or_facility_name: "",
          city_name: "",
        },
      },
      analyticData: {
        specialist: "Elsewhere",
        specialistInfo: false,
      },
    });
    this.closeSelected();
  }

  completeWithWentElsewhereInfo() {
    this.completed.emit({
      completionData: {
        other_provider: {
          provider_or_facility_name: this.providerOrFacilityName,
          city_name: this.cityName,
        },
      },
      analyticData: {
        specialist: "Elsewhere",
        specialistInfo: true,
      },
    });
    this.closeSelected();
  }
}
